import { post } from "@/utils/request";
export enum UrlEnums {
	messageSync = "/v1/api/message/sync", //获取消息记录
	queryAutoReply = "/v1/api/query-auto-reply", //获取自动回复模板
	queryEntrance = "/v1/api/query-entrance", //获取自动回复模板
	assignWorker = "/v1/api/assign-worker", // 分配（客服）
	apiReply = "/v1/api/reply", //获取回复数据
	markRead = "/v1/api/chat/mark-read", //标记已读
	errorReportUpload = "/v1/api/error-report/upload",
	replyMessage = "/v1/api/message/reply-message/sync", //获取回复的消息
}
export const queryEntrance = async () => post<any>({ url: UrlEnums.queryEntrance });
export const queryAutoReply = async (data: any) => post<any>({ url: UrlEnums.queryAutoReply, data });
export const messageSync = async (data: any) => post<any>({ url: UrlEnums.messageSync, data });
export const assignWorker = async (data: any) => post<any>({ url: UrlEnums.assignWorker, data });
export const setMarkRead = async (data: any) => post<any>({ url: UrlEnums.markRead, data });
export const errorReportUpload = async (data: any) => post<any>({ url: UrlEnums.errorReportUpload, data });
export const getReplyMessage = async (data: any) => post<any>({ url: UrlEnums.replyMessage, data });
